export * from "./footer.module";

